import type { components } from "../../../../types/api.types";
import { FieldName } from "./DeliveryForm/CustomFields/FieldNames";

export interface DeliveryFormOptions {
  sites: Array<{ value: number; label: string }>;
}

export interface DeliveryFormOptionsResponse {
  sites: Array<DeliveryFormOptionsChoice>;
}

interface DeliveryFormOptionsChoice {
  id: number;
  name: string;
}

export const INDIVIDUAL_MIX_FIELDS = [
  FieldName.NuclearPercentage,
  FieldName.CoalPercentage,
  FieldName.GasPercentage,
  FieldName.OtherFossilPercentage,
  FieldName.TenantPercentage,
  FieldName.RenewableNotPromotedPercentage,
  FieldName.RenewablePromotedPercentage,
  FieldName.YearMix,
  FieldName.EmissionCo2,
  FieldName.RadioactiveWaste
];

export type GridFees = components["schemas"]["GridFees"];
